import {animateByClass} from '../Library/Animation';
import {transitionByClass} from '../Library/Animation';
import {Gestures} from '../Library/Gestures';

const autoHideDelay = 4000;
const showDelay     = 100;

const dismissSwipeDistance = 100;

const dismissibleToastClosers = new Set();

export const render = (template) => {
    const toastContainer = document.querySelector('.toast-container');

    toastContainer.classList.add('active');

    const createMessage = () => {
        const toast = template.content.cloneNode(true).lastElementChild;

        if (template.dataset.autoHide) {
            registerAutoHide();
        }

        return toast;
    }

    const shakeExistingItems = () => {
        toastContainer.querySelectorAll('.toast-container .toast').forEach((toast) => {
            animateByClass(toast, 'make-space');
        });
    }

    const registerAutoHide = () => {
        autoHideTimeoutId = setTimeout(() => {
            close();
        }, autoHideDelay);
    }

    const unregisterAutoHide = () => {
        clearTimeout(autoHideTimeoutId);
    }

    const removeMessageFromDom = (toast) => {
        dismissibleToastClosers.delete(close);

        toast.parentNode.removeChild(toast);

        if (!toastContainer.children.length) {
            toastContainer.classList.remove('active');
        }
    };

    const close = async () => {
        await animateByClass(toast, 'hide');

        if (!document.contains(toast)) {
            return;
        }

        removeMessageFromDom(toast);
    }

    const handleAutoHideDelay = () => {
        toast.addEventListener('mouseenter', unregisterAutoHide);
        toast.addEventListener('touchstart', unregisterAutoHide);
        toast.addEventListener('mouseleave', registerAutoHide);
        toast.addEventListener('touchend', registerAutoHide);
    }

    let autoHideTimeoutId = undefined;

    const toast = createMessage();

    shakeExistingItems();

    setTimeout(() => {
        toastContainer.appendChild(toast);

        if (template.dataset.dismissible) {
            dismissibleToastClosers.add(close);
        }

        toast.querySelector('.close')?.addEventListener('click', close);

        animateByClass(toast, 'show');
    }, showDelay);

    if (template.dataset.autoHide) {
        handleAutoHideDelay();
    }

    if (template.dataset.dismissible) {
        Gestures({
            handles: [toast],
            onMove: (event) => {
                toast.classList.add('touching');

                if (event.movement.horizontal.direction === 'left') {
                    toast.style.transform = 'translateX(0px)';
                    toast.style.opacity = 1;
                } else {
                    toast.style.transform = `translateX(${event.movement.horizontal.delta}px)`;
                    toast.style.opacity   = (100 - event.movement.horizontal.delta) / 100;
                }
            },
            onSwipe: (event) => {
                if (event.movement.horizontal.direction === 'right' && event.movement.horizontal.delta > dismissSwipeDistance) {
                    removeMessageFromDom(toast);

                    return;
                }

                toast.style.transform  = 'translateX(0px)';
                toast.style.opacity    = 1;

                toast.classList.remove('touching');

                transitionByClass(toast, 'reset-position');
            }
        });
    }
}

export const initializeToastMessages = root => {
    root.querySelectorAll('template[data-template-type="toast"]').forEach(messageTemplate => {
        messageTemplate.parentNode.removeChild(messageTemplate);

        render(messageTemplate);
    });
};

export const fromString = (toastTemplate) => {
    render(new DOMParser().parseFromString(toastTemplate, 'text/html').querySelector('template'));
};

export const dismissAll = () => {
    dismissibleToastClosers.forEach((close) => close());
};
